module.exports = __webpack_public_path__ + "static/media/stripe.a9151b81.svg";